module.exports = __webpack_public_path__ + "img/startchat2.4bcf805b.png";